import React from 'react';
import './WhatSection.css';

const WhatSection = ({ windowWidth }) => (
  <section id="what" className="purpose-section overflow-visible mb-5">
    <div className="container">
      <div className="container section-dots-divider mt-5 mb-5"></div>
      <div className="mt-5">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <img src="/doctors.png" alt="Medical professionals in hospital corridor" className="img-fluid rounded" />
          </div>
          <div className="col-lg-6">
            <div className="purpose-built-content">
              <h2 className="purpose-built-title">
                Purpose-Built for Specialists.<br/>
                Designed to Expand.
              </h2>
              <p className="purpose-built-text">
                Trusted by thousands of clinicians worldwide.<br/>
                Optimized for anesthesiologists, pain specialists,<br/>
                and perioperative teams.<br/>
                New specialties continuously in development –<br/>
                <b>MAIA evolves with your clinical needs.</b>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default WhatSection; 